import React, { ReactElement, ReactNode } from 'react';
import styled from '@emotion/styled';
import { LoginView } from './constants';
import { TabList, TabPane, BackToLoginTab } from './Tabs/index';
import { SsoOptions } from './SsoOptions/index';

import { Text } from '../Text/component';
import { OL_COLOUR_KELP } from '../Style/colours';
import { MIXIN_ANCHOR_BUTTON } from '../Style/mixins';

import './styles.scss';

declare type LoginSignupProps = {
  view: LoginView;
  onSelectSignup: () => void;
  onSelectLogin: () => void;
  onBackToLoginClick: () => void;
  loginForm: ReactNode;
  signUpForm: ReactNode;
  resetPasswordForm: ReactNode;
  enableSSO: boolean;
};

const SelectTabButton = styled('button')({
  ...MIXIN_ANCHOR_BUTTON,
  fontWeight: 700,
  color: OL_COLOUR_KELP,
});

export const LoginSignup = React.memo(
  ({
    view,
    onSelectSignup,
    onSelectLogin,
    onBackToLoginClick,
    loginForm,
    signUpForm,
    resetPasswordForm,
    enableSSO,
  }: LoginSignupProps): ReactElement => {
    return (
      <div className="login-signup">
        {view === 'forgotPassword' ? (
          <>
            <BackToLoginTab onBackToLoginClick={onBackToLoginClick} />
            <TabPane selected singleColumn>
              {resetPasswordForm}
            </TabPane>
          </>
        ) : (
          <>
            <TabList {...{ view, onSelectSignup, onSelectLogin }} />

            <Text
              marginTop="24px"
              marginBottom="0"
              size="headingSm"
              fontWeight={400}
              textAlign="center"
            >
              {view === 'login' ? (
                <>
                  New to OpenLearning?{' '}
                  <SelectTabButton onClick={() => onSelectSignup()}>
                    Sign up
                  </SelectTabButton>
                </>
              ) : (
                <>
                  Already have an account?{' '}
                  <SelectTabButton onClick={() => onSelectLogin()}>
                    Log in
                  </SelectTabButton>
                </>
              )}
            </Text>

            <TabPane selected={view === 'signup'} singleColumn>
              {enableSSO && <SsoOptions {...{ view }} />}
              {view === 'signup' && signUpForm}
            </TabPane>
            <TabPane selected={view === 'login'} singleColumn>
              {enableSSO && <SsoOptions {...{ view }} />}
              {view === 'login' && loginForm}
            </TabPane>
          </>
        )}
      </div>
    );
  }
);
